import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function Sidebar() {
  const location = useLocation()
  const userRoleSlug = localStorage.getItem('user_role_slug')
  const isConsumer = userRoleSlug === 'consumer'
  const navigate = useNavigate()

  const menu = [
    { path: '/dashboard', label: 'Dashboard', roles: ['super_admin', 'admin', 'user', 'consumer'] },
    { path: '/data/group', label: isConsumer ? 'Akses Data' : 'Manajemen Data', roles: ['super_admin', 'admin', 'user', 'consumer'] },
    { path: '/users', label: 'Manajemen User', roles: ['super_admin', 'admin'] },
  ]

  return (
    <aside className="w-64 h-screen flex-shrink-0 bg-neutral-800 text-white p-4">
      <button onClick={() => navigate('/')}>
        <h1 className="text-xl font-bold mb-6">Profil Daerah</h1>
      </button>
      <div className='h-[92%] flex flex-col justify-between'>
        <nav className="space-y-2">
          {menu
            .filter(item => item.roles?.includes(userRoleSlug ?? ''))
            .map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`block px-3 py-2 rounded ${
                location.pathname.startsWith(path) ? 'bg-neutral-700 font-semibold' : 'hover:bg-neutral-700'
              }`}
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  )
}
